"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class ExecutionStep {
  constructor(stepId) {
    this.stepId = stepId;
    this.getParentId = () => {
      return this.parentId;
    };
    this.setParentId = parentId => {
      this.parentId = parentId;
    };
    this.status = "waiting";
  }
  getInputMessage() {
    return this.inputMessage;
  }
  getOutputMessage() {
    return this.outputMessage;
  }
  getStatus() {
    return this.status;
  }
  setStatus(s) {
    this.status = s;
  }
  setInputMessage(message) {
    this.inputMessage = message;
  }
  setOutputMessage(message) {
    this.outputMessage = message;
  }
}
exports.ExecutionStep = ExecutionStep;
//# sourceMappingURL=executionStep.js.map
